import { useRouter } from "next/router";
import { withTranslation } from "next-i18next";
import { Image } from "@components/core";

function GiftCardNavbar({ t }) {
  const router = useRouter();

  return (
    <div className="border-bottom d-flex justify-content-center align-items-center gift-card-navbar position-relative">
      <h1 className="mb-0 h3">{t("gift_cards:gift_cards_navbar_title")}</h1>
      <button
        type="button"
        className="btn-transparent position-absolute"
        style={{ left: 10 }}
        onClick={() => router.back()}
      >
        <Image
          src="arrowFat"
          alt={t("gift_cards:back")}
          className="back-button my-auto"
        />
      </button>

    </div>
  );
}

export default withTranslation("gift_cards")(GiftCardNavbar);
